var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    style: {
      width: "4em",
      height: "4em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 2691,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M384 128V16h-128v112",
    fill: "#D73636",
    "p-id": 2692
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M336 128V16h-80v112",
    fill: "#F73B2F",
    "p-id": 2693
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48 416v528h928V416",
    fill: "#FFE183",
    "p-id": 2694
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M976 416v528h-64V480H48v-64h928z",
    fill: "#D9BF6F",
    "p-id": 2695
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M577.408 352H16v64h488.288",
    fill: "#F73B2F",
    "p-id": 2696
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M833.232 416H1008v-64H768.784",
    fill: "#F73B2F",
    "p-id": 2697
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M368 656a96.048 96.048 0 0 0-28.112-67.888A96 96 0 0 0 176 656v96h192v-96z",
    fill: "#FFFFFF",
    "p-id": 2698
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M320 592h32v160h-32z",
    fill: "#D9D9D9",
    "p-id": 2699
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M256 352v64c0 12.736-5.056 24.944-14.064 33.936a47.936 47.936 0 0 1-67.872 0A47.936 47.936 0 0 1 160 416v-64H32L128 128h18.736a48.032 48.032 0 0 1 90.528 0h201.408A80.048 80.048 0 0 1 512 80a80.048 80.048 0 0 1 72.32 45.792A63.712 63.712 0 0 1 624 112c16.208 0 31.024 6.048 42.32 16h49.824A71.92 71.92 0 0 1 776 96c24.944 0 46.944 12.704 59.856 32H896l96 224H400v56a40 40 0 1 1-80 0V352h-64z",
    fill: "#CBE9EA",
    "p-id": 2700
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M896 128l96 224H416c324.768 19.904 531.216-28.112 480-224z",
    fill: "#ADC6C7",
    "p-id": 2701
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M496 528l176-176 176 176v352H496V528",
    fill: "#FFD140",
    "p-id": 2702
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M464 880h416v64H464z",
    fill: "#5AB947",
    "p-id": 2703
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M768 656a96.048 96.048 0 0 0-28.112-67.888 96.048 96.048 0 0 0-135.776 0A96.048 96.048 0 0 0 576 656v224h192V656z",
    fill: "#D73636",
    "p-id": 2704
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M648 563.44a92.4 92.4 0 0 1 43.888 24.672A96.048 96.048 0 0 1 720 656v224h-144V656c0-25.456 10.112-49.872 28.112-67.888a92.4 92.4 0 0 1 43.888-24.672z",
    fill: "#F73B2F",
    "p-id": 2705
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M496 528v64l176-176 144 144v320h32V512L672 352 496 528z",
    fill: "#D9B236",
    "p-id": 2706
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M640 720m-16 0a16 16 0 1 0 32 0 16 16 0 1 0-32 0Z",
    fill: "#F73B2F",
    "p-id": 2707
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M672.064 261.584v-0.016l242.624 234.688a32 32 0 0 1 0.768 45.232l-0.016 0.016a32 32 0 0 1-45.248 0.784L672.064 350.96 474.496 541.744a31.936 31.936 0 0 1-45.248-0.8l-0.016-0.016a32 32 0 0 1 0.768-45.232l242.064-234.112z",
    fill: "#F73B2F",
    "p-id": 2708
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M40.32 960.784A104.064 104.064 0 0 1 136 816a103.68 103.68 0 0 1 71.6 28.592 79.584 79.584 0 0 0 71.312 20.864A108.944 108.944 0 0 1 296 864c48.576 0 88 39.424 88 88",
    fill: "#CBE9EA",
    "p-id": 2709
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M16 944h992v64H16z",
    fill: "#5AB947",
    "p-id": 2710
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.8cb3688b6bedcbd57678e1191c5ab1a0.svg";
export { ForwardRef as ReactComponent };